/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState } from 'react';
// material
import { ColorPicker } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/commenting/addons/communitysection/customcolorscheme/customcolorscheme_styles';



/* ========== ~~~~~~~~~~ ADD-ON COMMUNITY CUSTOM COLOR SCHEME ~~~~~~~~~~ ========== */
const CustomColorScheme = props => {

    const [customColorPickers, setCustomColorPickers] = useState([
        {label: 'Background', name: 'background', color: props.data.background, valid: true, type: 'custom'},
        {label: 'Secondary Text', name: 'secondaryText', color: props.data.secondaryText, valid: true, type: 'custom'},
        {label: 'Primary Text', name: 'primaryText', color: props.data.primaryText, valid: true, type: 'custom'},
        {label: 'Branding', name: 'branding', color: props.data.branding, valid: true, type: 'custom'},
        {label: 'Primary Button Labels', name: 'primaryButtonLabel', color: props.data.primaryButtonLabel, valid: true, type: 'special'},
        {label: 'Error Validation', name: 'errorValidation', color: props.data.errorValidation, valid: true, type: 'special'}
    ]);

    const [savedColorPickers, setSavedColorPickers] = useState([...customColorPickers]);

    const updateColorPicker = (name, prop, value) => {
        const index = customColorPickers.map(picker => picker.name).indexOf(name);
        const colorPickers = [...customColorPickers];
        colorPickers[index] = {...colorPickers[index], [prop]: value};
        setCustomColorPickers(colorPickers);
        const isInvalidColor = colorPickers.filter(picker => picker.valid === false).length > 0;
        props.onValidate(!isInvalidColor);
    }

    const processColorUpdate = (color, name) => {
        const hex = color.replace('#','').trim();
        updateColorPicker(name, 'color', hex);
        props.onChange({...props.data, [name]: hex});
    }
    
    const validateColor = (isValid, name) => {
        updateColorPicker(name, 'valid', isValid);
    }

    const handleReset = name => {
        const index = savedColorPickers.map(picker => picker.name).indexOf(name);
        const colorPickers = [...customColorPickers];
        colorPickers[index] = {...savedColorPickers[index]};
        setCustomColorPickers(colorPickers);
    }

    return (
        <div className={`colorscheme ${props.classes.colorscheme} section`}>
            <div className={`sectioncontent`}>
                { customColorPickers.filter(picker => picker.type === 'custom').map(picker => 
                    <ColorPicker 
                      label={picker.label} 
                      valid={picker.valid}
                      color={`#${picker.color.length === 6 ? picker.color : 'FFFFFF'}`} 
                      savedColor={picker.color}
                      processColorUpdate={(color, e) => processColorUpdate(color, picker.name)} 
                      validateColor={(isValid, e) => validateColor(isValid, picker.name)} 
                      handleReset={() => handleReset(picker.name)}
                    />
                )}
           
                <h4>Configure special colors if you see any color conflict in the preview mode</h4>
                
                { customColorPickers.filter(picker => picker.type === 'special').map(picker => 
                    <ColorPicker 
                        label={picker.label} 
                        valid={picker.valid}
                        color={`#${picker.color.length === 6 ? picker.color : 'FFFFFF'}`} 
                        savedColor={picker.color}
                        processColorUpdate={(color, e) => processColorUpdate(color, picker.name)} 
                        validateColor={(isValid, e) => validateColor(isValid, picker.name)} 
                        handleReset={() => handleReset(picker.name)}
                    />
                )}
            </div>
        </div>
    )
}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(CustomColorScheme);